import type {
  ExploreImportRequest,
  ExploreImportResponse,
  ExplorePage,
  ExploreTab,
} from '@mcgames/contracts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useApiMutation } from '../../api/hooks.ts';
import { http } from '../../api/http.ts';

const EXPLORE_PATH = '/api/admin/explore';
const IMPORT_PATH = '/api/admin/explore/import';

/** What the page shows: a store list, or a search across Steam and GOG. */
export type ExploreSource = { kind: 'tab'; tab: ExploreTab } | { kind: 'search'; q: string };

export function explorePath(source: ExploreSource, page: number): string {
  const params = new URLSearchParams();
  if (source.kind === 'tab') {
    params.set('tab', source.tab);
  } else {
    params.set('q', source.q);
  }
  params.set('page', String(page));
  const base = source.kind === 'tab' ? EXPLORE_PATH : `${EXPLORE_PATH}/search`;
  return `${base}?${params.toString()}`;
}

/** The pages of a list or search loaded so far; `fetchNextPage` loads one more. */
export function useExplore(source: ExploreSource) {
  return useInfiniteQuery({
    queryKey: [EXPLORE_PATH, source],
    queryFn: ({ pageParam }) => http<ExplorePage>('GET', explorePath(source, pageParam)),
    initialPageParam: 1,
    getNextPageParam: (last: ExplorePage) => (last.hasMore ? last.page + 1 : undefined),
  });
}

export function useExploreImport() {
  return useApiMutation<ExploreImportRequest, ExploreImportResponse>('POST', IMPORT_PATH);
}
